import { connect } from 'react-redux';
import Drivers from '../../components/Dispatch/Drivers';
import { checkPermission } from '../../actions/settings_actions';

function mapStateToProps(state) {
  return {
    checkingPermission: state.settings.checkingPermission,
    checkPermissionSuccess: state.settings.checkPermissionSuccess,
    checkPermissionFailure: state.settings.checkPermissionFailure,
  };
}

export default connect(mapStateToProps, { checkPermission })(Drivers);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/Drivers.jsx